export default __webpack_public_path__ + "static/media/image.3babf10f.jpg";